import React from 'react';
import { FileText, CheckCircle, AlertCircle } from 'lucide-react';

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-ivory-50 to-stone-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 animate-fade-in">
          <FileText className="h-12 w-12 text-copper mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-steel mb-2">Conditions d'Utilisation</h1>
          <p className="text-stone">Prototype MemoMundi.ai</p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 animate-slide-up space-y-8">
          
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-6">
            <div className="flex items-center space-x-3 mb-3">
              <AlertCircle className="h-6 w-6 text-amber-600" />
              <h2 className="text-xl font-semibold text-steel">Statut Prototype</h2>
            </div>
            <p className="text-steel">
              MemoMundi.ai est actuellement en phase de prototype. Ces conditions d'utilisation 
              sont provisoires et seront étoffées lors du lancement officiel.
            </p>
          </div>

          <section>
            <h2 className="text-2xl font-semibold text-steel mb-4 flex items-center">
              <CheckCircle className="h-6 w-6 mr-2 text-copper" />
              Utilisation du service
            </h2>
            <div className="space-y-3 text-steel">
              <p>En utilisant MemoMundi.ai, vous acceptez de :</p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-copper rounded-full mt-2"></div>
                  <span>Respecter les autres utilisateurs et la communauté</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-copper rounded-full mt-2"></div>
                  <span>Publier uniquement des conversations authentiques</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-copper rounded-full mt-2"></div>
                  <span>Ne pas utiliser le service à des fins malveillantes</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-copper rounded-full mt-2"></div>
                  <span>Respecter les droits de propriété intellectuelle</span>
                </li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-steel mb-4">Contenu publié</h2>
            <div className="space-y-3 text-steel">
              <p>Concernant les conversations (Appendex) que vous publiez :</p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-sky rounded-full mt-2"></div>
                  <span>Vous conservez vos droits d'auteur</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-sky rounded-full mt-2"></div>
                  <span>Vous accordez à MemoMundi une licence d'utilisation</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-2 h-2 bg-sky rounded-full mt-2"></div>
                  <span>Le contenu doit respecter nos standards communautaires</span>
                </li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-steel mb-4">Marques MMD™</h2>
            <div className="bg-ivory/50 p-6 rounded-lg">
              <p className="text-steel mb-4">
                Les technologies et marques suivantes sont propriété de MemoMundi.ai :
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
                <span className="bg-white p-2 rounded text-center">Veritas™</span>
                <span className="bg-white p-2 rounded text-center">MemoStamp™</span>
                <span className="bg-white p-2 rounded text-center">Companion ID™</span>
                <span className="bg-white p-2 rounded text-center">Praesentia™</span>
                <span className="bg-white p-2 rounded text-center">Like IA™</span>
                <span className="bg-white p-2 rounded text-center">Instance Interact™</span>
                <span className="bg-white p-2 rounded text-center">Memory™</span>
                <span className="bg-white p-2 rounded text-center">Modules MMD™</span>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-steel mb-4">Limitation de responsabilité</h2>
            <div className="text-steel space-y-2">
              <p>
                En tant que prototype, MemoMundi.ai est fourni "en l'état" sans garantie 
                de disponibilité ou de performance.
              </p>
              <p className="text-sm text-stone">
                Conditions complètes disponibles lors du lancement commercial.
              </p>
            </div>
          </section>

          <div className="text-center pt-8 border-t border-stone/20">
            <p className="text-sm text-stone">
              Dernière mise à jour : Janvier 2024 • Version Prototype
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;